export const videoPositions = [
  { name: 'ai', x: 192, y: 60, width: 94, height: 94 },
  { name: 'trading', x: 118, y: 124, width: 88, height: 88 },
  { name: 'blockchain', x: 216, y: 168, width: 90, height: 90 },
  { name: 'innovative', x: 280, y: 262, width: 92, height: 92 },
  { name: 'frontier', x: 118, y: 380, width: 88, height: 88 },
];
